import { ArrowLeftIcon } from '@/ui/common/Icons/ArrowLeftIcon';

type TSliderLeftBtn = {
    onClick: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
};

export const SliderLeftBtn = ({ onClick }: TSliderLeftBtn) => (
    <button
        onClick={onClick}
        className="slider-btn left-3"
        type="button"
        data-test-id="slider-left"
        title="previous-image"
    >
        <ArrowLeftIcon />
    </button>
);
